import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslation from './translations/en.json';
import esTranslation from './translations/es.json';

i18n
    .use(LanguageDetector) // Detects user language
    .use(initReactI18next) // Integrates with React
    .init({
        resources: {
            en: { translation: enTranslation },
            es: { translation: esTranslation },
        },
        fallbackLng: 'en', // Fallback language
        supportedLngs: ['en', 'es'], // Supported languages
        interpolation: {
            escapeValue: false, // React handles XSS by default
        },
        detection: {
            order: ['localStorage', 'navigator'], // Language detection priority
            caches: ['localStorage'], // Store language preference
        },
    });

export default i18n;